/* eslint-disable max-lines-per-function */
import { DEFAULT_PAGINATION_SIZE } from "@/v1/config/constants";

function BaseStore(entityName, initialState) {
  const baseState = {
    filters: [
      {
        key: "status",
        title: "label.status",
        icon: "status",
        active: false,
        values: [],
        metadata: [],
      },
    ],
    results: [],
    loading: true,
    page: {
      size: DEFAULT_PAGINATION_SIZE,
      totalElements: 0,
      totalPages: 0,
      number: 0,
    },
    query: {
      includeDeleted: false,
      page: 0,
      sort: {},
    },
    selectedAll: false,
    selectedRows: [],
    detail: {
      loading: true,
    },
  };

  const initialMergedState = Object.freeze(
    Object.assign(
      {},
      baseState,
      typeof initialState === "function" ? initialState(baseState) : initialState,
    ),
  );

  this.state = { ...initialMergedState };
  this.reducer =
    (statements) =>
      (state = this.state, action = {}) => {
        const { payload, type } = action;
        const baseReducers = {
          [`@${entityName}/GET_LIST_START`]: () => ({
            ...state,
            loading: true,
          }),
          [`@${entityName}/GET_LIST_SUCCESS`]: () => ({
            ...state,
            ...payload,
            loading: false,
          }),
          [`@${entityName}/SET_QUERY_PARAMS`]: () => ({
            ...state,
            query: {
              ...state.query,
              ...payload.query,
            },
            filters: payload.filters,
          }),
          [`@${entityName}/SET_FILTERS`]: () => ({
            ...state,
            filters: payload,
          }),
          [`@${entityName}/CLEAR_FILTERS`]: () => ({
            ...state,
            filters: payload.filters,
          }),
          [`@${entityName}/INCLUDE_DELETED`]: () => ({
            ...state,
            query: {
              ...state.query,
              includeDeleted: payload.includeDeleted,
            },
          }),
          [`@${entityName}/SELECT_ROW`]: () => ({
            ...state,
            selectedRows: payload.rows,
            selectedAll: false,
          }),
          [`@${entityName}/SELECT_ALL`]: () => ({
            ...state,
            selectedRows: [],
            selectedAll: payload.selectedAll,
          }),
          [`@${entityName}/GET_DETAIL_START`]: () => ({
            ...state,
            detail: {
              ...state.detail,
              loading: true,
            },
          }),
          [`@${entityName}/GET_DETAIL_SUCCESS`]: () => {
            let finalDetail = {
              ...state,
              detail: {
                ...state.detail,
                ...payload.detail,
                loading: false,
              },
            };

            if (entityName === "operators" || entityName === "casinos" || entityName === "software") {
              finalDetail = {
                ...state,
                detail: {
                  ...payload.detail,
                  loading: false,
                },
              };
            }
            return finalDetail;
          },
          [`@${entityName}/RESET_STORE`]: () => ({
            ...initialMergedState,
          }),
        };

        const mergedReducers = Object.freeze(Object.assign({}, baseReducers, statements));
        const handler = mergedReducers[type];

        if (handler) {
          return handler(state, payload);
        }

        return state;
      };
}

export default BaseStore;
